import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  BarElement,
} from "chart.js";
import { Bar, } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Filler,
  Legend
);


export default function BarChart({ chartValue, data, labels }) {


  const chartData = {
    labels,
    datasets: [
      {
        label: 'Başarılı',
        data: (chartValue == 1 ? data?.salesAmount?.map((item) => (item)) : data?.salesCounts?.map((item) => item)),
        backgroundColor: 'rgba(90, 194, 247)',
      },
      {
        label: 'Başarısız',
        data: data != null && (chartValue == 1 ? data?.errorAmount?.map((item) => (item)) : data?.errorCounts?.map((item) => item)),
        backgroundColor: 'rgba(22, 118, 243)',
      },
      {
        label: 'İade',
        data: data != null && (chartValue == 1 ? data?.refundAmount?.map((item) => (item)) : data?.refundCounts?.map((item) => item)),
        backgroundColor: 'rgba(255, 125, 148)',
      },
    ],
  }
  const getChartMaxAmountFromAmount = (amount) => {

  

    return null
  }

const getChartMax = () => {
  let result = chartValue == 2 ? 10 : 100;

  if (data != null) {

    if (chartValue == 1 && data?.maxAmount > 0) {
      let maxAmount = data?.maxAmount;
      result = getChartMaxAmountFromAmount(maxAmount);
    } else if (chartValue == 2 && data?.maxCount > 0) {
      result = getChartMaxAmountFromAmount(data?.maxCount)
    }
  }
  return result;
}

return (
  <div className="bg-white   flex flex-row h-full xs:w-full justify-center items-center  w-full">
    {
      <Bar
        options={{
          plugins: {
            legend: {
              display: false,
              position: "bottom"
            }
          },
          scales: {
            x: {
              offset: true
            },
            y: {
              display: true,
              min: 0,
              max: getChartMax(),
              beginAtZero: true,
              title: {
                text: chartValue == 1 ? "İşlem Tutarı" : "İşlem Adedi",
                display: true,
                padding: 2,
                align: 'center',
                color: '#1C304A',
                font: {
                  size: 12,
                },
              },


            }
          },

        }}
        width={688}
        height={200}
        data={chartData}
      />

    }

  </div>
);
}
